import { HttpClient } from '@angular/common/http';
import { ThisReceiver } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CommonService {


  private domain = `${environment.domain}`;

  constructor(private http: HttpClient, private router: Router) { }

  getUsernameArabic(email: string) {
    const body = { ActionName: "GetUserNameArabic", "RequestJSON": JSON.stringify({ Email: email }) }
    return this.http.post(`${this.domain}/api/data/v9.2/adca_InvokeCRM`, body)
  }

  getShortName(fullName: string) {
    if (fullName !== null) {
      let shortName = fullName
        .split(' ')
        .map((n) => n[0])
        .join('');
      return shortName.slice(0, 2);
    }
    return ("NA")
  }

  navigateToCRM(url: string) {
    window.open(url, '_blank');
  }

  getSystemUsers(keyword) {
    const body = {
      ActionName: "GetUserList",
      "RequestJSON": JSON.stringify({ QuickFindFilter: keyword })
    }
    return this.http.post(`${this.domain}/api/data/v9.2/adca_InvokeCRM`, body).pipe(map((result: any) => {
      return {
        ...result,
        ResponseMessage: JSON.parse(result.ResponseMessage)
      }
    }))
  }

  convertRatingToScale(ratingPercentage: number): string {
    const range = 100 / 5;
    const rating = Math.ceil(ratingPercentage / range);
    const convertedRating = Math.min(Math.max(rating, 0), 5);
    return convertedRating.toString();
  }
}

export function UAEIDValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value || value.length !== 15) {
      return null;
    }
    const firstThreeDigits = value.substring(0, 3);
    if (!['784'].includes(firstThreeDigits)) {
      return { invalidUAEID: true };
    }
    const yearPart = parseInt(value.substring(3, 7), 10);
    if (yearPart < 1900 || yearPart > 2050) {
      return { invalidUAEID: true };
    }
    return null;
  };
}
